module.exports = __webpack_public_path__ + "static/media/trainingReinforcementIcon.18a50c1e.png";